import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ISubscription, Subscription } from 'rxjs/Subscription';
import { Observable, Subject } from 'rxjs/Rx';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService, DBService, DownLoadService } from '../../service';
import { Result, Table, outputGraph } from '../../model/small-molecule.model';
import { AnalysisDetails, DownloadFile, NewTable, SearchResult } from '../../model/analysis-details.model';
import { SharedService } from '../../layouts/shared-service';
import { User } from '../../model/types';
import { DropDownService } from '../../service/drop-down.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AppLoaderService } from '../../service/app-loader/app-loader.service';
import { interval } from 'rxjs/internal/observable/interval';
import { error } from 'console';
import { bool } from 'aws-sdk/clients/signer';
import { AuthNewService } from '../../service/auth-new.service';
import { catchError, delay, switchMap, take, takeUntil } from 'rxjs/operators';
import { StorageService } from '../../service/storage.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import jsPDF from 'jspdf';
import htmlToPdfmake from 'html-to-pdfmake';
pdfMake.vfs = pdfFonts.vfs;

@Component({
    selector: 'app-small-molecule',
    templateUrl: './small-molecule.component.html',
    styleUrls: ['./small-molecule.component.scss']
})
export class SmallMoleculeComponent implements OnInit, OnDestroy {

    pageTitle = 'Analyze Report/Data';
    signedInUser: any;
    analysisId = '';
    searchResult: SearchResult = <SearchResult>{};
    // analysisResponseNew: SearchResult = <SearchResult>{};
    selectedTables: string;
    analysisDetails: AnalysisDetails;
    public tables: Table[] = [];
    tablesKey: any = [];
    tablesValue: any = [];
    stattablesKey: any = [];
    stattablesValue: any = [];
    tablesList: NewTable[];
    tablesNotFound: any = [];
    tableData: any;
    tableAnalysisType: string;
    routersub: ISubscription;
    callerSubscription: Subscription;
    tableSelected = false;
    tableProcessed = false;
    reviewTableSelection = false;
    public results: Result[];
    tempData: any;
    title = 'Loading';
    mysubscription: any;
    visibleData = 0;
    public showcharts = false;
    item;
    output_graph: outputGraph[];
    graphs: any[] = [];
    private singleSearchData: Subscription;
    private currentLoginUser: Subscription;
    private PostEventData: Subscription;
    private getEventData: Subscription;
    // public Histograms = [];
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild('htmlData', { static: false }) htmlData!: ElementRef;
    @ViewChild('auditData', { static: false }) auditData!: ElementRef;
    AuditPdfData;
    ParsedPdfData;
    EventDataUrl: string = environment.serverUrl + '/event-data';
    DownloadFileobject: DownloadFile = <DownloadFile>{};
    AnalysisViewType: string;
    userGroup: any;
    userOrganization: any;
    // @ViewChild('textData') data: ElementRef;

    step = 0;
    updateOptions: Object;
    data: any;
    options: {};
    navigationSubscription: Subscription;
    usr: any;
    formType: any;
    currentUser: User;
    illegalUser: boolean;
    sData: SearchResult;
    checked: boolean = false;
    disabled: boolean = false;
    displayTable: boolean = false;
    isFetching: boolean = true;
    displayPDFData: boolean = true;
    displayExPanels: boolean = true;
    searchResultData: boolean = true;
    errortable: any;
    extractrunid = [];
    columnArray = [];
    dataArray = [];
    jsonDataArray = [];
    displayObservation: boolean = false;
    signedInUserAccess;
    output_path: string;
    logo: string;
    pollingSubscription: Subscription;
     private stopPolling = new Subject<void>();

    constructor(private _sharedService: SharedService,
        private activatedroute: ActivatedRoute,
        private authService: AuthService,
        private AuthService: AuthNewService,
        private elRef: ElementRef,
        private router: Router,
        private http: HttpClient,
        // private ngxXml2jsonService: NgxXml2jsonService,
        private dbService: DBService,
        private dropDownService: DropDownService,
        private downloadService: DownLoadService,
        public dialog: MatDialog,
        private ref: ChangeDetectorRef,
        private loader: AppLoaderService,
        private storageService: StorageService,
        public datepipe: DatePipe) {
        this._sharedService.emitChange(this.pageTitle);
        // if(this.tables.length==0){
        //     this.openDialog()
        // }


        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.initialiseInvites();
            }
        });




    }


    initialiseInvites() {
        this.authService.getCurrentUser((err, user: User) => {
            this.currentUser = user;
            this.activatedroute.paramMap.subscribe((params) => {
                if (params.get('user') !== this.currentUser.username) {
                    return
                } else {
                    this.usr = params.get('user');
                    this.analysisId = params.get('id');
                }

            });
        });

    }

    async ngOnInit() {
        this.pollForResult();
        this.AnalysisViewType = this.activatedroute.snapshot.paramMap.get('type');
        try {
            const data = await this.dbService.singleSearch.pipe(take(1)).toPromise();
            if (Object.keys(data).length === 0) {
                this.searchResultData = false;
            } else {
                this.isFetching = false;

            }
            data && this.populateResultData(data);
            this.loadImageAsBase64('/assets/img/App-Biodata.png');
        } catch (error) {
            console.error('Error occurred:', error);
        }

    }

    loadImageAsBase64(url: string) {
        this.http.get(url, { responseType: 'blob' }).subscribe((blob: Blob) => {
            const reader = new FileReader();
            reader.onload = () => {
                this.logo = reader.result as string;
            };
            reader.readAsDataURL(blob);
        });
    }


    ToggleState(event) {
        this.displayTable = !this.displayTable;

    }
    ToggleState2(event) {
        this.displayObservation = !this.displayObservation;
    }

    ToggleState1(event) {
        this.displayPDFData = !this.displayPDFData;
        this.displayExPanels = !this.displayExPanels;
        this.displayTable = false;
    }

    openDialog() {
        this.loader.open(this.title);

    }

    closeDialog() {

        this.loader.close();
    }

    // ngAfterViewInit() {
    //     let li = this.data.nativeElement.value;

    // }
    showCharts() {
        this.showcharts = true;
    }

    async pollForResult() {
        this.AuthService.getAuthenticatedUser().then(async (usr) => {
            this.signedInUser = usr;
            if (!this.signedInUser) {
                this.router.navigate(['/extra-layout/signin']);
            } else {
                this.AuthService.getUserAttributes().then(async (attrs) => {
                    this.userGroup = attrs['custom:group'];
                    this.userOrganization = attrs['custom:organization'];
                    this.signedInUserAccess = attrs['custom:access'];
                    this.activatedroute.paramMap.subscribe(async (params) => {
                        if (this.signedInUserAccess == 'SU' || this.signedInUserAccess == 'GA' || this.signedInUserAccess == 'QA' || this.signedInUserAccess == 'PI') {
                            this.illegalUser = false;
                            this.usr = params.get('user');
                            this.analysisId = params.get('id');
                            if (this.AnalysisViewType == null) {
                                const status = await this.fetchAnalysisStatus();
                            }
                            this.dbService.getAnalysisDetails(this.usr, this.analysisId);
                        }
                    });
            });
            }

        }, (error) => {
            console.log(error);
        });
    }

    async fetchAnalysisStatus(): Promise<string> {
        return new Promise((resolve, reject) => {
            this.pollingSubscription = interval(5000)
                .pipe(
                    switchMap(() =>
                        this.dbService.getAnalysisStatus(
                            this.usr,
                            this.analysisId,
                            this.userOrganization,
                            this.userGroup
                        )
                    ),
                    takeUntil(this.stopPolling),
                    catchError((error) => {
                        console.error('Polling error:', error);
                        reject(error);
                        return [];
                    })
                )
                .subscribe(
                    (data) => {
                        const dataStatus = data.data['analysis_status'];
                            if (dataStatus === 'Complete' || dataStatus === 'Pending' || dataStatus === 'Error' || dataStatus== 'Validation Complete') {
                                this.stopPolling.next(); // Stop polling when the desired status is reached
                                resolve(dataStatus);
                            }
//                         console.log(`Polled status: ${dataStatus}`);
                        
                    },
                    (error) => {
                        console.error('Error during polling:', error);
                        reject(error);
                    }
                );
        });
    }



    setStep(index: number) {
        this.step = index;

    }

    nextStep(table: Table, selection: boolean) {
        table.valid = selection;
        this.step++;

        for (const obj of this.tables) {
            if (obj.valid === true || obj.valid === false) {
                this.tableSelected = true;
            } else {
                this.tableSelected = false;
                break;
            }
        }
    }


    getCount(result: Result, color: string) {
        let count = 0
        for (const resultItem of result.resultItem) {
            for (const items of resultItem.item) {
                if (items.color === color) {
                    count = count + items.message.length
                }
            }
        }
        return count;
    }

    getColor(level: string): string {
        if (level === 'Green') {
            return '#C5EEB2'
        } else if (level === 'Yellow') {
            return '#F8F8A9'
        } else if (level === 'Info') {
            return '#75cff8'
        } else if (level === 'Red') {
            return '#EEC2B7'
        }
    }


    processResult() {

        for (const result of this.results) {
            for (const resultItem of result.resultItem) {
                for (const item of resultItem.item) {
                    item.colorCode = this.getColor(item.color);
                }
            }
        }
        this.formType = this.searchResult.analysisType;
        // console.log("actual link", this.searchResult.analysisResultFile);
        //         const output_file = this.getSignedURL(this.searchResult.analysisResultFile);
        //         this.searchResult.analysisResultFile = output_file
        const output_data = this.getSignedURL(this.searchResult.analysisResultData);
        // this.output_path = output_data;
        //         console.log(this.searchResult);
        if (this.searchResult.ParsedDataPath) {
            //             console.log(this.searchResult.ParsedDataPath);
            this.downloadService.getS3Obj(this.searchResult.ParsedDataPath).then(
                data => {
                    //                     console.log(data.trim().split(/\n/));
                    this.ParsedPdfData = data.trim().split(/\n/).map((line) => JSON.parse(line));
                    //                     console.log(this.ParsedPdfData);
                }
            );
        }
        //         const output_file2 = this.getSignedURL(this.searchResult.AnalysisResultXlsxFile);
        //         this.searchResult.AnalysisResultXlsxFile = output_file2;
        //         try {
        //             this.output_graph = JSON.parse(this.searchResult.AnalysisResultGraph);
        //         } catch (error) {
        //         }
    }
    findKey(table) {
        //    this.arraytoJson(table)
        return table.hasOwnProperty('error')
    }


    populateResultData(data: SearchResult) {
        //         this.tablesList = [];
        this.searchResult = data;
        //         this.tableAnalysisType = this.searchResult.analysisSubtype;
        //         this.tablesList = this.searchResult.Tables;
        //         this.tablesNotFound = this.searchResult.MissingTables;
        const status = this.searchResult.analysisStatus;
        // TableSelected, NewAnalysis, Complete
        //         if (this.searchResult.analysisStatus === 'TableSelected' || this.searchResult.analysisStatus === 'Processed') {
        //             this.openDialog()
        //         }
        //         if (this.searchResult.analysisStatus === 'Complete' || this.searchResult.analysisStatus === 'Error') {
        //             this.closeDialog()
        //         }

        //         this.analysisDetails = JSON.parse(this.searchResult?.analysisDetails);
        if (status === 'TableResult') {

            if ((this.searchResult.Tables?.length > 4)) {

            }

        } else if (status === 'TableSelected') {
            this.selectedTables = this.searchResult.selectedTables;
            this.pollForResult()
        } else if (status === 'Complete' || status === 'Validation Complete') {
            this.results = JSON.parse(this.searchResult.analysisResult);
            const eventName = 'View';
            this.DownloadFileobject.userId = this.storageService.get('userId');
            this.DownloadFileobject.eventName = eventName;
            this.DownloadFileobject.analysisId = this.analysisId;
            this.DownloadFileobject.analysisType = 'Regression';
            this.DownloadFileobject.userName = this.storageService.get('userName');
            this.DownloadFileobject.filePath = this.searchResult?.audit_file_path;
            this.DownloadFileobject.userRole = this.storageService.get('access');
            let params = new HttpParams();
            params = params.append('analysisId', this.analysisId);

            this.PostEventData = this.http.post(this.EventDataUrl, this.DownloadFileobject).subscribe(
                (response) => {

                    this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
                        (res) => {
                            this.AuditPdfData = res;
                        }
                    )
                },
                (error) => {
                    console.error('API call error:', error);
                }
            );

            this.processResult();

        } else if (status === 'Error') {

        }
    }


    tableFlag(text: string) {
        const flag = text.startsWith('<table') || text.startsWith('graph');
        return flag

    }

    getDisplayString(key) {
        return this.dropDownService.nameDescMap.get(key);
    }

    getSignedURL(path: string) {
        if (path.indexOf('https') !== -1) {
            return path;
        } else if (/\S/.test(path)) {
            return this.downloadService.getUrl(path, false, this.searchResult.analysisType);
        } else {
            return ' ';
        }

    }

    getOutputFilePath() {
        //  TODO: Refactor this into a service/method
        const eventName = 'Download';
        this.DownloadFileobject.userId = this.storageService.get('userId');
        this.DownloadFileobject.eventName = eventName;
        this.DownloadFileobject.analysisId = this.analysisId;
        this.DownloadFileobject.analysisType = 'Regression';
        this.DownloadFileobject.userName = this.storageService.get('userName');
        this.DownloadFileobject.filePath = this.searchResult?.audit_file_path;
        this.DownloadFileobject.userRole = this.storageService.get('access');

        let params = new HttpParams();
        params = params.append('analysisId', this.analysisId);

        this.PostEventData = this.http.post(this.EventDataUrl, this.DownloadFileobject).subscribe(
            (response) => {

                this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
                    (res) => {
                        this.AuditPdfData = res;

                    }
                )
            },
            (error) => {
                console.error('API call error:', error);
            }
        );
        return this.output_path;
    }

    review() {
        const tableObjects: Table[] = JSON.parse(this.searchResult.selectedTables);
        const table_indexes: string[] = new Array();
        for (const tab of tableObjects) {
            table_indexes.push(tab.table_index)
        }

        for (const table of this.tables) {
            if (table_indexes.includes(table.table_index)) {
                table.valid = true;
            } else {
                table.valid = false;
            }
        }

        this.reviewTableSelection = true;
    }

    openGraph() {
        this.output_graph.forEach((element) => {
            const link = this.getSignedURL(element.key);
            const title = element.title;
            this.graphs.push(link);
        })
        // this.dialog.open(GraphDialogComponent, { data: { name: this.graphs }, disableClose: false, height: '540px', width: '82%' });

    }
    ngOnDestroy(): void {
        if (this.callerSubscription) {
            this.callerSubscription.unsubscribe();
        }
        if (this.mysubscription) {
            this.mysubscription.unsubscribe();
        }

        if (this.singleSearchData) {
            this.singleSearchData.unsubscribe();
        }
        if (this.currentLoginUser) {
            this.currentLoginUser.unsubscribe();
        }
        if (this.getEventData) {
            this.getEventData.unsubscribe();
        }
        if (this.PostEventData) {
            this.PostEventData.unsubscribe();
        }


    }

    exportAuditPDF() {
        let maxDate = new Date();
        const maxAuditUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
        const doc = new jsPDF();
        const pdfTable = this.auditData?.nativeElement;
        let html = htmlToPdfmake(pdfTable.innerHTML);
        const documentDefinition = {
            content: [
                {
                    image: this.logo,
                    width: 150,
                    style: 'logo',
                    margin: [0, 10, 10, 10],
                    fontSize: 10,
                },
                {
                    text: maxAuditUTCDate,
                    width: 35,
                    style: 'date',
                    fontSize: 10,
                },
                {
                    text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 20, 10, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'Analyte Name: ', bold: true }, this.searchResult.analyteNames[0]],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread User ID: ', bold: true }, this.searchResult.userId],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread Analysis Date(UTC): ', bold: true }, this.searchResult.analysisDate],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: ("AUDIT REPORT"),
                    width: 100,
                    bold: true,
                    alignment: 'center',
                    margin: [10, 20, 10, 10],
                    decoration: 'underline',
                    fontSize: 15,
                },
                html
            ],
            styles: {
                logo: {
                    alignment: 'left',
                },
                date: {
                    alignment: 'right',
                }
            }
        };
        pdfMake.createPdf(documentDefinition).download('RedThread Audit.pdf')
    }

    exportPDF() {
        let maxDate = new Date();
        const maxUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
        const doc = new jsPDF();
        const pdfTable = this.htmlData?.nativeElement;
        let html = htmlToPdfmake(pdfTable.innerHTML);

        const documentDefinition = {
            content: [
                {
                    image: this.logo,
                    width: 150,
                    style: 'logo',
                },
                {
                    text: maxUTCDate,
                    width: 35,
                    style: 'date',
                    bold: true,
                    fontSize: 10,

                },
                {
                    text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 20, 10, 0],
                    fontSize: 10,

                },
                {
                    text: [{ text: 'Analyte Name: ', bold: true }, this.searchResult.analyteNames[0]],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread User ID: ', bold: true }, this.searchResult.userId],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread Analysis Date(UTC): ', bold: true }, this.searchResult.analysisDate],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: ('RedThread Parsed Input Data Report'),
                    width: 100,
                    bold: true,
                    alignment: 'center',
                    margin: [10, 20, 10, 10],
                    decoration: 'underline',
                    fontSize: 15,
                },
                html

            ],
            styles: {
                logo: {
                    alignment: 'left',
                },
                date: {
                    alignment: 'right'
                }
            }
        };
        pdfMake.createPdf(documentDefinition).download('RedThread Parsed Input Report.pdf');
    }

}
